import React from 'react';
import Lottie from 'lottie-react';
import animationData from './RocketManAnimation.json';
import './RocketManAnimation.css';

const RocketManAnimation = () => {
  const style = {
    height: 600,
    width: 500,
  };

  return (
    <div className="rocket-container">
      <Lottie
        animationData={animationData}
        loop
        autoplay
        style={style}
        rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
      />
    </div>
  );
};

export default RocketManAnimation;
